import React, {PureComponent, ComponentType} from "react"
import styled, {css} from "styled-components"

import {Card} from "@irati/ui/src/Layout"
import {Caption} from "@irati/ui/src/Labels"
import {H4} from "@irati/ui/src/Headings"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {injectIntl, FormattedMessage, InjectIntl} from "@irati/utils/lang"
import TrophyImg from "@irati/ui/src/Trophy"
import {Inspiration} from "@irati/types"
import {maxLengthString, hasWhitespace} from "@irati/utils/string"
import getId from "@irati/utils/id"

const StyledCard = styled(Card)`
  ${minWidthMedia.tablet`
    min-height: 130px;
  `}
  :hover {
    box-shadow: none;
  }
`

const FlexRow = styled.div`
  align-items: flex-start;
  display: flex;
  height: 100%;
`

const StyledImg = styled.img`
  flex: none;
  margin-right: 10px;
  width: 60px;
  height: 60px;
`

const StyledTrophyImg = styled.div`
  flex: none;
  margin-right: 10px;
`

const StyledDiv = styled(({whitespace, ...rest}) => <div {...rest} />)`
  height: 100%;
  width: 100%;
  word-break: break-word;
  ${({whitespace}) =>
    whitespace ||
    css`
      word-break: break-all; /* need this for firefox */
      word-break: break-word;
    `}
`

interface Props extends InjectIntl {
  inspiration: Inspiration,
  onClick(value: Inspiration): void,
  StyledTextButton: ComponentType,
  id: string
}

class InspirationTile extends PureComponent<Props> {
  handleClick = () => {
    const {
      formatMessage,
      inspiration: {desc, id, isCompanyValue, title, trophy},
      onClick
    } = this.props

    const {alt, href} = trophy

    const data = {
      companyValues: isCompanyValue ? [id] : [],
      desc: isCompanyValue ? desc : formatMessage({id: desc}),
      title: isCompanyValue ? title : formatMessage({id: title}),
      trophy: {
        alt: isCompanyValue ? alt : formatMessage({id: alt}),
        href: isCompanyValue ? href : formatMessage({id: href})
      }
    }
    onClick(data)
  }

  render() {
    const {formatMessage, inspiration, StyledTextButton} = this.props

    const {desc, isCompanyValue, title, trophy} = inspiration

    const idNamespace = getId("inspirationTile", this.props)

    const MAX_TITLE_LENGTH = 40
    const MAX_CAPTION_LENGTH = 70

    return (
      <StyledTextButton id={idNamespace} onClick={this.handleClick} inline={false}>
        <StyledCard tiny>
          <FlexRow>
            {isCompanyValue ? (
              <StyledTrophyImg>
                <TrophyImg src={trophy.href} size="60px" />
              </StyledTrophyImg>
            ) : (
              <StyledImg alt={formatMessage({id: trophy.alt})} src={formatMessage({id: trophy.href})} />
            )}
            <StyledDiv whitespace={hasWhitespace({value: title})}>
              <H4 withBody>
                {isCompanyValue ? maxLengthString({value: title, length: MAX_TITLE_LENGTH}) : <FormattedMessage id={title} />}
              </H4>
              <Caption flush>
                {isCompanyValue ? maxLengthString({value: desc, length: MAX_CAPTION_LENGTH}) : <FormattedMessage id={desc} />}
              </Caption>
            </StyledDiv>
          </FlexRow>
        </StyledCard>
      </StyledTextButton>
    )
  }
}

export default injectIntl(InspirationTile)
